"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DummySpeechGenerator = void 0;
const abstract_speech_generator_1 = require("./abstract_speech_generator");
class DummySpeechGenerator extends abstract_speech_generator_1.AbstractSpeechGenerator {
    getSpeech(_node, _xml) {
        return '';
    }
}
exports.DummySpeechGenerator = DummySpeechGenerator;
